const selectSearch = (state) => state.search;

export const selectSearchTerm = (state) => selectSearch(state).term;
